import styled from "styled-components";
import { Link } from "react-router-dom";

export const NavigationContainer = styled.header`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.75rem 1rem;
  background-color: #fffaf4;
  border-bottom: 1px solid #f0e0cf;
`;

export const NavInner = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1.5rem;

  @media (max-width: 768px) {
    /* 👇 stack items and center them on mobile */
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
`;

export const LogoContainer = styled(Link)`
  display: inline-flex;
  align-items: baseline;   /* 👈 ALWAYS baseline */
  gap: 0.5rem;
  text-decoration: none;
  margin: 0 auto;          /* 👈 centers horizontally on mobile */

  @media (max-width: 768px) {
    /* DO NOT change align-items here */
    margin: 0 auto;
  }
`;


export const LogoImage = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
    display: block;
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
  }
`;

export const Brand = styled.span`
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #333;
  line-height: 1;
`;

export const NavLinksWrapper = styled.nav`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 0.25rem;
  flex: 1;

  @media (max-width: 768px) {
    /* 👇 nav row centered under logo on mobile */
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const NavLink = styled(Link)`
  padding: 0.5rem 0.75rem;
  border-radius: 999px;
  font-size: 0.95rem;
  text-decoration: none;
  color: #444;
  cursor: pointer;
  line-height: 1;

  &:hover {
    background-color: #ffe4c4;
  }

  &:focus-visible {
    outline: 2px solid #333;
    outline-offset: 2px;
  }
`;
